module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Niederwil_AG-87e8b94ce64fdcb8bf376454cd6f451c.svg";